module.exports = __webpack_public_path__ + "static/media/arrow-down-dark.07bf010c.svg";